module.exports = __webpack_public_path__ + "img/main_logo2.a5cb2e5b.png";